export const setDefaultAvatar = (element) => {
  element.target.src = 'https://sportstrader.s3.amazonaws.com/default_profile_image.png';
};
